package org.matthewo.api

import kotlin.jvm.JvmName
import kotlinx.serialization.Serializable
import kotlin.math.roundToInt
import org.matthewo.symbolprocessor.Period.*
import org.matthewo.schema.MetricsMeta
import org.matthewo.schema.games.*
import org.matthewo.math.plus
import org.matthewo.math.convert

@Serializable
data class MetricsIntoTheDeepCRIAPI<N : Number>(
    override val total: N,
    override val npTotal: N,
    override val auto: N,
    override val teleop: N,
    override val endgame: N,
    override val penalty: N,
    override val apOwned: N,
    override val apNavigation: N,
    override val tpOwned: N,
    override val epNavigation: N,
    override val epCoopertition: N,
    override val apSampleNetNear: N,
    override val apSampleLowNear: N,
    override val apSampleHighNear: N,
    override val apSampleNetFar: N,
    override val apSampleLowFar: N,
    override val apSampleHighFar: N,
    override val apSpecimenLow1: N,
    override val apSpecimenHigh1: N,
    override val apSpecimenLow2: N,
    override val apSpecimenHigh2: N,
    override val apSpecimenLow3: N,
    override val apSpecimenHigh3: N,
    override val apSpecimenLow4: N,
    override val apSpecimenHigh4: N,
    override val tpSampleNetNear: N,
    override val tpSampleLowNear: N,
    override val tpSampleHighNear: N,
    override val tpSampleNetFar: N,
    override val tpSampleLowFar: N,
    override val tpSampleHighFar: N,
    override val tpSpecimenLow1: N,
    override val tpSpecimenHigh1: N,
    override val tpSpecimenLow2: N,
    override val tpSpecimenHigh2: N,
    override val tpSpecimenLow3: N,
    override val tpSpecimenHigh3: N,
    override val tpSpecimenLow4: N,
    override val tpSpecimenHigh4: N,
) : MetricsAPI<N>, MetricsIntoTheDeepCRI<N> {
    constructor(team1: MetricsIntoTheDeepCRI<N>, team2: MetricsIntoTheDeepCRI<N>) : this(
        total = team1.total + team2.total,
        npTotal = team1.npTotal + team2.npTotal,
        auto = team1.auto + team2.auto,
        teleop = team1.teleop + team2.teleop,
        endgame = team1.endgame + team2.endgame,
        penalty = team1.penalty + team2.penalty,
        apOwned = team1.apOwned + team2.apOwned,
        apNavigation = team1.apNavigation + team2.apNavigation,
        tpOwned = team1.tpOwned + team2.tpOwned,
        epNavigation = team1.epNavigation + team2.epNavigation,
        epCoopertition = team1.epCoopertition + team2.epCoopertition,
        apSampleNetNear = team1.apSampleNetNear + team2.apSampleNetNear,
        apSampleLowNear = team1.apSampleLowNear + team2.apSampleLowNear,
        apSampleHighNear = team1.apSampleHighNear + team2.apSampleHighNear,
        apSampleNetFar = team1.apSampleNetFar + team2.apSampleNetFar,
        apSampleLowFar = team1.apSampleLowFar + team2.apSampleLowFar,
        apSampleHighFar = team1.apSampleHighFar + team2.apSampleHighFar,
        apSpecimenLow1 = team1.apSpecimenLow1 + team2.apSpecimenLow1,
        apSpecimenHigh1 = team1.apSpecimenHigh1 + team2.apSpecimenHigh1,
        apSpecimenLow2 = team1.apSpecimenLow2 + team2.apSpecimenLow2,
        apSpecimenHigh2 = team1.apSpecimenHigh2 + team2.apSpecimenHigh2,
        apSpecimenLow3 = team1.apSpecimenLow3 + team2.apSpecimenLow3,
        apSpecimenHigh3 = team1.apSpecimenHigh3 + team2.apSpecimenHigh3,
        apSpecimenLow4 = team1.apSpecimenLow4 + team2.apSpecimenLow4,
        apSpecimenHigh4 = team1.apSpecimenHigh4 + team2.apSpecimenHigh4,
        tpSampleNetNear = team1.tpSampleNetNear + team2.tpSampleNetNear,
        tpSampleLowNear = team1.tpSampleLowNear + team2.tpSampleLowNear,
        tpSampleHighNear = team1.tpSampleHighNear + team2.tpSampleHighNear,
        tpSampleNetFar = team1.tpSampleNetFar + team2.tpSampleNetFar,
        tpSampleLowFar = team1.tpSampleLowFar + team2.tpSampleLowFar,
        tpSampleHighFar = team1.tpSampleHighFar + team2.tpSampleHighFar,
        tpSpecimenLow1 = team1.tpSpecimenLow1 + team2.tpSpecimenLow1,
        tpSpecimenHigh1 = team1.tpSpecimenHigh1 + team2.tpSpecimenHigh1,
        tpSpecimenLow2 = team1.tpSpecimenLow2 + team2.tpSpecimenLow2,
        tpSpecimenHigh2 = team1.tpSpecimenHigh2 + team2.tpSpecimenHigh2,
        tpSpecimenLow3 = team1.tpSpecimenLow3 + team2.tpSpecimenLow3,
        tpSpecimenHigh3 = team1.tpSpecimenHigh3 + team2.tpSpecimenHigh3,
        tpSpecimenLow4 = team1.tpSpecimenLow4 + team2.tpSpecimenLow4,
        tpSpecimenHigh4 = team1.tpSpecimenHigh4 + team2.tpSpecimenHigh4,
    )
    
    companion object {
        inline operator fun <reified N : Number> invoke(team1: MetricsIntoTheDeepCRI<*>, team2: MetricsIntoTheDeepCRI<*>) = MetricsIntoTheDeepCRIAPI(
            total = team1.total.convert<N>() + team2.total.convert<N>(),
            npTotal = team1.npTotal.convert<N>() + team2.npTotal.convert<N>(),
            auto = team1.auto.convert<N>() + team2.auto.convert<N>(),
            teleop = team1.teleop.convert<N>() + team2.teleop.convert<N>(),
            endgame = team1.endgame.convert<N>() + team2.endgame.convert<N>(),
            penalty = team1.penalty.convert<N>() + team2.penalty.convert<N>(),
            apOwned = team1.apOwned.convert<N>() + team2.apOwned.convert<N>(),
            apNavigation = team1.apNavigation.convert<N>() + team2.apNavigation.convert<N>(),
            tpOwned = team1.tpOwned.convert<N>() + team2.tpOwned.convert<N>(),
            epNavigation = team1.epNavigation.convert<N>() + team2.epNavigation.convert<N>(),
            epCoopertition = team1.epCoopertition.convert<N>() + team2.epCoopertition.convert<N>(),
            apSampleNetNear = team1.apSampleNetNear.convert<N>() + team2.apSampleNetNear.convert<N>(),
            apSampleLowNear = team1.apSampleLowNear.convert<N>() + team2.apSampleLowNear.convert<N>(),
            apSampleHighNear = team1.apSampleHighNear.convert<N>() + team2.apSampleHighNear.convert<N>(),
            apSampleNetFar = team1.apSampleNetFar.convert<N>() + team2.apSampleNetFar.convert<N>(),
            apSampleLowFar = team1.apSampleLowFar.convert<N>() + team2.apSampleLowFar.convert<N>(),
            apSampleHighFar = team1.apSampleHighFar.convert<N>() + team2.apSampleHighFar.convert<N>(),
            apSpecimenLow1 = team1.apSpecimenLow1.convert<N>() + team2.apSpecimenLow1.convert<N>(),
            apSpecimenHigh1 = team1.apSpecimenHigh1.convert<N>() + team2.apSpecimenHigh1.convert<N>(),
            apSpecimenLow2 = team1.apSpecimenLow2.convert<N>() + team2.apSpecimenLow2.convert<N>(),
            apSpecimenHigh2 = team1.apSpecimenHigh2.convert<N>() + team2.apSpecimenHigh2.convert<N>(),
            apSpecimenLow3 = team1.apSpecimenLow3.convert<N>() + team2.apSpecimenLow3.convert<N>(),
            apSpecimenHigh3 = team1.apSpecimenHigh3.convert<N>() + team2.apSpecimenHigh3.convert<N>(),
            apSpecimenLow4 = team1.apSpecimenLow4.convert<N>() + team2.apSpecimenLow4.convert<N>(),
            apSpecimenHigh4 = team1.apSpecimenHigh4.convert<N>() + team2.apSpecimenHigh4.convert<N>(),
            tpSampleNetNear = team1.tpSampleNetNear.convert<N>() + team2.tpSampleNetNear.convert<N>(),
            tpSampleLowNear = team1.tpSampleLowNear.convert<N>() + team2.tpSampleLowNear.convert<N>(),
            tpSampleHighNear = team1.tpSampleHighNear.convert<N>() + team2.tpSampleHighNear.convert<N>(),
            tpSampleNetFar = team1.tpSampleNetFar.convert<N>() + team2.tpSampleNetFar.convert<N>(),
            tpSampleLowFar = team1.tpSampleLowFar.convert<N>() + team2.tpSampleLowFar.convert<N>(),
            tpSampleHighFar = team1.tpSampleHighFar.convert<N>() + team2.tpSampleHighFar.convert<N>(),
            tpSpecimenLow1 = team1.tpSpecimenLow1.convert<N>() + team2.tpSpecimenLow1.convert<N>(),
            tpSpecimenHigh1 = team1.tpSpecimenHigh1.convert<N>() + team2.tpSpecimenHigh1.convert<N>(),
            tpSpecimenLow2 = team1.tpSpecimenLow2.convert<N>() + team2.tpSpecimenLow2.convert<N>(),
            tpSpecimenHigh2 = team1.tpSpecimenHigh2.convert<N>() + team2.tpSpecimenHigh2.convert<N>(),
            tpSpecimenLow3 = team1.tpSpecimenLow3.convert<N>() + team2.tpSpecimenLow3.convert<N>(),
            tpSpecimenHigh3 = team1.tpSpecimenHigh3.convert<N>() + team2.tpSpecimenHigh3.convert<N>(),
            tpSpecimenLow4 = team1.tpSpecimenLow4.convert<N>() + team2.tpSpecimenLow4.convert<N>(),
            tpSpecimenHigh4 = team1.tpSpecimenHigh4.convert<N>() + team2.tpSpecimenHigh4.convert<N>(),
        )
    }
}

inline fun <reified N : Number> MetricsIntoTheDeepCRI<*>.convert() = serialize { convert<N>() }

fun <N : Number> MetricsIntoTheDeepCRI<N>.serialize() = MetricsIntoTheDeepCRIAPI(
    total = total,
    npTotal = npTotal,
    auto = auto,
    teleop = teleop,
    endgame = endgame,
    penalty = penalty,
    apOwned = apOwned,
    apNavigation = apNavigation,
    tpOwned = tpOwned,
    epNavigation = epNavigation,
    epCoopertition = epCoopertition,
    apSampleNetNear = apSampleNetNear,
    apSampleLowNear = apSampleLowNear,
    apSampleHighNear = apSampleHighNear,
    apSampleNetFar = apSampleNetFar,
    apSampleLowFar = apSampleLowFar,
    apSampleHighFar = apSampleHighFar,
    apSpecimenLow1 = apSpecimenLow1,
    apSpecimenHigh1 = apSpecimenHigh1,
    apSpecimenLow2 = apSpecimenLow2,
    apSpecimenHigh2 = apSpecimenHigh2,
    apSpecimenLow3 = apSpecimenLow3,
    apSpecimenHigh3 = apSpecimenHigh3,
    apSpecimenLow4 = apSpecimenLow4,
    apSpecimenHigh4 = apSpecimenHigh4,
    tpSampleNetNear = tpSampleNetNear,
    tpSampleLowNear = tpSampleLowNear,
    tpSampleHighNear = tpSampleHighNear,
    tpSampleNetFar = tpSampleNetFar,
    tpSampleLowFar = tpSampleLowFar,
    tpSampleHighFar = tpSampleHighFar,
    tpSpecimenLow1 = tpSpecimenLow1,
    tpSpecimenHigh1 = tpSpecimenHigh1,
    tpSpecimenLow2 = tpSpecimenLow2,
    tpSpecimenHigh2 = tpSpecimenHigh2,
    tpSpecimenLow3 = tpSpecimenLow3,
    tpSpecimenHigh3 = tpSpecimenHigh3,
    tpSpecimenLow4 = tpSpecimenLow4,
    tpSpecimenHigh4 = tpSpecimenHigh4,
)

@JvmName("serializeGeneric")
fun <T : Number, R : Number> MetricsIntoTheDeepCRI<T>.serialize(serializer: T.() -> R) = MetricsIntoTheDeepCRIAPI(
    total = total.serializer(),
    npTotal = npTotal.serializer(),
    auto = auto.serializer(),
    teleop = teleop.serializer(),
    endgame = endgame.serializer(),
    penalty = penalty.serializer(),
    apOwned = apOwned.serializer(),
    apNavigation = apNavigation.serializer(),
    tpOwned = tpOwned.serializer(),
    epNavigation = epNavigation.serializer(),
    epCoopertition = epCoopertition.serializer(),
    apSampleNetNear = apSampleNetNear.serializer(),
    apSampleLowNear = apSampleLowNear.serializer(),
    apSampleHighNear = apSampleHighNear.serializer(),
    apSampleNetFar = apSampleNetFar.serializer(),
    apSampleLowFar = apSampleLowFar.serializer(),
    apSampleHighFar = apSampleHighFar.serializer(),
    apSpecimenLow1 = apSpecimenLow1.serializer(),
    apSpecimenHigh1 = apSpecimenHigh1.serializer(),
    apSpecimenLow2 = apSpecimenLow2.serializer(),
    apSpecimenHigh2 = apSpecimenHigh2.serializer(),
    apSpecimenLow3 = apSpecimenLow3.serializer(),
    apSpecimenHigh3 = apSpecimenHigh3.serializer(),
    apSpecimenLow4 = apSpecimenLow4.serializer(),
    apSpecimenHigh4 = apSpecimenHigh4.serializer(),
    tpSampleNetNear = tpSampleNetNear.serializer(),
    tpSampleLowNear = tpSampleLowNear.serializer(),
    tpSampleHighNear = tpSampleHighNear.serializer(),
    tpSampleNetFar = tpSampleNetFar.serializer(),
    tpSampleLowFar = tpSampleLowFar.serializer(),
    tpSampleHighFar = tpSampleHighFar.serializer(),
    tpSpecimenLow1 = tpSpecimenLow1.serializer(),
    tpSpecimenHigh1 = tpSpecimenHigh1.serializer(),
    tpSpecimenLow2 = tpSpecimenLow2.serializer(),
    tpSpecimenHigh2 = tpSpecimenHigh2.serializer(),
    tpSpecimenLow3 = tpSpecimenLow3.serializer(),
    tpSpecimenHigh3 = tpSpecimenHigh3.serializer(),
    tpSpecimenLow4 = tpSpecimenLow4.serializer(),
    tpSpecimenHigh4 = tpSpecimenHigh4.serializer(),
)

@JvmName("serializeDouble")
fun MetricsIntoTheDeepCRI<Double>.serialize() = serialize { roundToInt().toShort() }

@JvmName("serializeNumber")
fun MetricsIntoTheDeepCRI<Number>.serialize() = serialize { toShort() }

fun MetricsIntoTheDeepCRI<*>.stringify() = """
        total: $total
        npTotal: $npTotal
        auto: $auto
        teleop: $teleop
        endgame: $endgame
        penalty: $penalty
        apOwned: $apOwned
        apNavigation: $apNavigation
        tpOwned: $tpOwned
        epNavigation: $epNavigation
        epCoopertition: $epCoopertition
        apSampleNetNear: $apSampleNetNear
        apSampleLowNear: $apSampleLowNear
        apSampleHighNear: $apSampleHighNear
        apSampleNetFar: $apSampleNetFar
        apSampleLowFar: $apSampleLowFar
        apSampleHighFar: $apSampleHighFar
        apSpecimenLow1: $apSpecimenLow1
        apSpecimenHigh1: $apSpecimenHigh1
        apSpecimenLow2: $apSpecimenLow2
        apSpecimenHigh2: $apSpecimenHigh2
        apSpecimenLow3: $apSpecimenLow3
        apSpecimenHigh3: $apSpecimenHigh3
        apSpecimenLow4: $apSpecimenLow4
        apSpecimenHigh4: $apSpecimenHigh4
        tpSampleNetNear: $tpSampleNetNear
        tpSampleLowNear: $tpSampleLowNear
        tpSampleHighNear: $tpSampleHighNear
        tpSampleNetFar: $tpSampleNetFar
        tpSampleLowFar: $tpSampleLowFar
        tpSampleHighFar: $tpSampleHighFar
        tpSpecimenLow1: $tpSpecimenLow1
        tpSpecimenHigh1: $tpSpecimenHigh1
        tpSpecimenLow2: $tpSpecimenLow2
        tpSpecimenHigh2: $tpSpecimenHigh2
        tpSpecimenLow3: $tpSpecimenLow3
        tpSpecimenHigh3: $tpSpecimenHigh3
        tpSpecimenLow4: $tpSpecimenLow4
        tpSpecimenHigh4: $tpSpecimenHigh4
    """.trimIndent()

object MetricsIntoTheDeepCRIMeta : MetricsMeta<MetricsIntoTheDeepCRI<*>> {
    override val names = linkedMapOf(
        MetricsIntoTheDeepCRI<*>::total to "Total",
        MetricsIntoTheDeepCRI<*>::npTotal to "NP Total",
        MetricsIntoTheDeepCRI<*>::auto to "Auto",
        MetricsIntoTheDeepCRI<*>::teleop to "Teleop",
        MetricsIntoTheDeepCRI<*>::endgame to "Endgame",
        MetricsIntoTheDeepCRI<*>::penalty to "Foul",
        MetricsIntoTheDeepCRI<*>::apSampleNet to "Sample Net",
        MetricsIntoTheDeepCRI<*>::apSampleLow to "Sample Low",
        MetricsIntoTheDeepCRI<*>::apSampleHigh to "Sample High",
        MetricsIntoTheDeepCRI<*>::apSpecimenLow to "Specimen Low",
        MetricsIntoTheDeepCRI<*>::apSpecimenHigh to "Specimen High",
        MetricsIntoTheDeepCRI<*>::apOwned to "Ownership",
        MetricsIntoTheDeepCRI<*>::apNavigation to "Navigation",
        MetricsIntoTheDeepCRI<*>::tpSampleNet to "Sample Net",
        MetricsIntoTheDeepCRI<*>::tpSampleLow to "Sample Low",
        MetricsIntoTheDeepCRI<*>::tpSampleHigh to "Sample High",
        MetricsIntoTheDeepCRI<*>::tpSpecimenLow to "Specimen Low",
        MetricsIntoTheDeepCRI<*>::tpSpecimenHigh to "Specimen High",
        MetricsIntoTheDeepCRI<*>::tpOwned to "Ownership",
        MetricsIntoTheDeepCRI<*>::epNavigation to "Navigation",
        MetricsIntoTheDeepCRI<*>::epCoopertition to "Coopertition",
    )
    
    override val periods = linkedMapOf(
        MetricsIntoTheDeepCRI<*>::total to ALL,
        MetricsIntoTheDeepCRI<*>::npTotal to ALL,
        MetricsIntoTheDeepCRI<*>::auto to AUTO,
        MetricsIntoTheDeepCRI<*>::teleop to TELEOP,
        MetricsIntoTheDeepCRI<*>::endgame to ENDGAME,
        MetricsIntoTheDeepCRI<*>::penalty to ALL,
        MetricsIntoTheDeepCRI<*>::apSampleNet to AUTO,
        MetricsIntoTheDeepCRI<*>::apSampleLow to AUTO,
        MetricsIntoTheDeepCRI<*>::apSampleHigh to AUTO,
        MetricsIntoTheDeepCRI<*>::apSpecimenLow to AUTO,
        MetricsIntoTheDeepCRI<*>::apSpecimenHigh to AUTO,
        MetricsIntoTheDeepCRI<*>::apOwned to AUTO,
        MetricsIntoTheDeepCRI<*>::apNavigation to AUTO,
        MetricsIntoTheDeepCRI<*>::tpSampleNet to TELEOP,
        MetricsIntoTheDeepCRI<*>::tpSampleLow to TELEOP,
        MetricsIntoTheDeepCRI<*>::tpSampleHigh to TELEOP,
        MetricsIntoTheDeepCRI<*>::tpSpecimenLow to TELEOP,
        MetricsIntoTheDeepCRI<*>::tpSpecimenHigh to TELEOP,
        MetricsIntoTheDeepCRI<*>::tpOwned to TELEOP,
        MetricsIntoTheDeepCRI<*>::epNavigation to ENDGAME,
        MetricsIntoTheDeepCRI<*>::epCoopertition to ENDGAME,
    )
}
